import {
  CLEAR_ALL_VALUES,
  FETCH_ALL_TAGS_ASYNC,
  FETCH_DEPARTMENTS_ASYNC,
  FETCH_TITLES_ASYNC,
  SET_ALL_TAGS_PAGE,
  SET_ALL_TAGS_SEARCH,
  SET_DEPARTMENTS_PAGE,
  SET_DEPARTMENTS_SEARCH,
  SET_SELECTED_ALL_TAGS,
  SET_SELECTED_DEPARTMENT,
  SET_SELECTED_TITLE,
  SET_TITLES_PAGE,
  SET_TITLES_SEARCH,
} from './constants'

const fetchAllTags = () => ({ type: FETCH_ALL_TAGS_ASYNC.INITIATE })
const fetchAllTagsCancel = () => ({ type: FETCH_ALL_TAGS_ASYNC.CANCEL })
export const fetchAllTagsSuccess = (data) => ({
  type: FETCH_ALL_TAGS_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchAllTagsError = (error) => ({ type: FETCH_ALL_TAGS_ASYNC.ERROR, error })

const fetchTitles = () => ({ type: FETCH_TITLES_ASYNC.INITIATE })
const fetchTitlesCancel = () => ({ type: FETCH_TITLES_ASYNC.CANCEL })
export const fetchTitlesSuccess = (data) => ({
  type: FETCH_TITLES_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchTitlesError = (error) => ({
  type: FETCH_TITLES_ASYNC.ERROR,
  error,
})

const fetchDepartments = () => ({ type: FETCH_DEPARTMENTS_ASYNC.INITIATE })
const fetchDepartmentsCancel = () => ({ type: FETCH_DEPARTMENTS_ASYNC.CANCEL })
export const fetchDepartmentsSuccess = (data) => ({
  type: FETCH_DEPARTMENTS_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchDepartmentsError = (error) => ({
  type: FETCH_DEPARTMENTS_ASYNC.ERROR,
  error,
})

const setAllTagsPage = (page) => ({
  type: SET_ALL_TAGS_PAGE,
  payload: { page },
})
const setAllTagsSearch = (search) => ({
  type: SET_ALL_TAGS_SEARCH,
  payload: { search },
})
const setDepartmentsPage = (page) => ({
  type: SET_DEPARTMENTS_PAGE,
  payload: { page },
})
const setDepartmentsSearch = (search) => ({
  type: SET_DEPARTMENTS_SEARCH,
  payload: { search },
})
const setTitlesPage = (page) => ({
  type: SET_TITLES_PAGE,
  payload: { page },
})
const setTitlesSearch = (search) => ({
  type: SET_TITLES_SEARCH,
  payload: { search },
})

const selectedTitleChange = (value) => ({
  type: SET_SELECTED_TITLE,
  payload: { value },
})
const selectedDepartmentChange = (value) => ({
  type: SET_SELECTED_DEPARTMENT,
  payload: { value },
})
const selectedAllTagsChange = (value) => ({
  type: SET_SELECTED_ALL_TAGS,
  payload: { value },
})

export const clearAddMailboxModalValues = () => ({ type: CLEAR_ALL_VALUES })

export default {
  // to props
  fetchAllTags,
  fetchAllTagsCancel,
  fetchAllTagsError,
  fetchAllTagsSuccess,
  fetchTitles,
  fetchTitlesCancel,
  fetchTitlesSuccess,
  fetchTitlesError,
  fetchDepartments,
  fetchDepartmentsCancel,
  fetchDepartmentsSuccess,
  fetchDepartmentsError,
  setAllTagsPage,
  setAllTagsSearch,
  setTitlesPage,
  setTitlesSearch,
  setDepartmentsPage,
  setDepartmentsSearch,
  selectedTitleChange,
  selectedDepartmentChange,
  selectedAllTagsChange,
}
